module.exports = __webpack_public_path__ + "static/media/avatar-c.6fc9c088.png";